import { render, staticRenderFns } from "./di-contact-owner.vue?vue&type=template&id=68002144"
import script from "./di-contact-owner.vue?vue&type=script&lang=ts"
export * from "./di-contact-owner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports